export default [
  {
    path: "/logisticsQuery",
    name: "logisticsQuery",
    component: () => import("../pages/logisticsQuery/logisticsQuery"),
    meta: {
      title: "物流查询"
    }
  }
];
